export default __webpack_public_path__ + "static/media/book.4eed58b4.svg";